import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contactformaarbic";

function Gettouch({ rtl }) {
  const className = rtl ? "gettouch p-100 rtl-style" : "gettouch  p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <h2>
              اتصل بنا اليوم ودع المتخصصين لدينا يساعدونك في رحلتك الرقمية
            </h2>
            <p>
              مستعدون لتحويل فكرة تطبيقك إلى حقيقة؟ TekRevol هنا لتحقيق ذلك!
              سواء كنت في الولايات المتحدة، كندا، مجلس التعاون الخليجي، أو
              المملكة المتحدة، فإن فريقنا مستعد لتحويل رؤيتك إلى واقع. يبدأ
              نهجنا البسيط بمحادثة حول مشروعك. لا لغة معقدة، لا مصطلحات معقدة -
              فقط دردشة ودية لفهم احتياجاتك. نحن هنا، جاهزون لمناقشة أهدافك. كل
              ما عليك فعله هو إعطاء زر "تواصل" نقرة خفيفة ولطيفة
            </p>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <ContentFrom rtl="rtl" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
